import { connect } from "react-redux";

var RosterUploadInitial = require("components/org/roster_upload/RosterUploadInitial");
var RosterUploadColumns = require("components/org/roster_upload/RosterUploadColumns");
var RosterUploadClasses = require("components/org/roster_upload/RosterUploadClasses");
var RosterUploadGrades = require("components/org/roster_upload/RosterUploadGrades");
var RosterUploadConfirm = require("components/org/roster_upload/RosterUploadConfirm");
var RosterUploadProgressMeter = require("components/org/roster_upload/RosterUploadProgressMeter");
var PendingTaskNotice = require("components/layout/PendingTaskNotice");
var CurrentUser = require("lib/account/CurrentUser");
var StudentRoster = require("lib/data/StudentRoster");
var Spinner = require("components/utility/Spinner");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("org/roster_upload/upload_student_roster.scss");

@connect(
	(state, props) => {
		var studentLists = RosterSelectors.nonEmptyStudentLists({ state });
		var methodOptions = STAGES;

		// remove Google if using Clever, otherwise remove Clever
		if (CurrentUser.isCleverSSOUser()) {
			methodOptions = _.without(methodOptions, GOOGLE);
		} else {
			methodOptions = _.without(methodOptions, CLEVER);
		}

		// also remove Google & clever option for non teacherAdmins
		if (!CurrentUser.isTeacherAdmin()) {
			methodOptions = _.without(methodOptions, GOOGLE);
			methodOptions = _.without(methodOptions, CLEVER);
		}

		if (!(CurrentUser.isTeacherAdmin() || CurrentUser.isWizard())) {
			methodOptions = _.without(methodOptions, UPLOAD);
		}

		return {
			methodOptions, studentLists,
			effectiveUserID: CurrentUser.get().id
		}
	},
	(dispatch, props) => ({
		uploadRoster: (studentsData) => {
			
			var effectiveUserID = CurrentUser.get().user_type == "Wizard" ? props.effectiveUserID : CurrentUser.get().id

			return dispatch(RosterActions.postRosters({ studentsData, effectiveUserID })).then((response) => {
				$(window.document).trigger("onboarding-trigger-add-students");
				if (props.afterCreate) {
					props.afterCreate(response.student_count, null, null, response.classrooms);
				}
				if (props.onUpload) {
					props.onUpload(response.student_count, false, PendingTaskNotice.UPLOADING_STUDENTS);
				}
			})
		},

		fetchArchivedStudentLists: () => {
			
			var effectiveUserID = CurrentUser.get().user_type == "Wizard" ? props.effectiveUserID : CurrentUser.get().id
			
			var query = {
				inactive: true,
				effective_user_id: effectiveUserID,
				embed: "student_list.students,student_list.primary_students"
			}

			return dispatch(RosterActions.fetchStudentListsStoreless({ query }))
		}
	})
)
class UploadStudentRoster extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		LuckyOrangeClient.tagComponent("RosterUpload");
		this.state = {
			stage: INITIAL, rosterData: null, archivedStudents: null
		};
	}

	// Go backwards if inReverse is present and true
	nextStage(inReverse) {
		if (this.state.stage == INITIAL && (CurrentUser.isSchoolAdmin() || CurrentUser.isWizard())) {
			this.props.fetchArchivedStudentLists().then(response => {
				var students = _.flatten(_.pluck(response.student_lists, "primary_students"));
				this.setState({ archivedStudents: students })
			})
		}

		var currentIndex = STAGES.indexOf(this.state.stage);
		var change = inReverse ? -1 : 1;
		var nextStage = STAGES[currentIndex + change];

		this.setState({ stage: nextStage });

		if (nextStage == DONE) {
			this.props.uploadRoster(this.state.rosterData)
		}

	}

	updateRosterData(updatedData, callback) {
		this.setState({ rosterData: updatedData }, callback);
	}

	render() {
		var roster = new StudentRoster(this.state.rosterData);
		var stageProps = {
			roster: roster, nextStage: this.nextStage,
			updateRosterData: this.updateRosterData
		};

		switch (this.state.stage) {
			case INITIAL:
				var stageContent = (<RosterUploadInitial {...stageProps} />);
				break;

			case COLUMNS:
				var stageContent = (<RosterUploadColumns {...stageProps} />);
				break;

			case GRADES:
				var stageContent = (<RosterUploadGrades {...stageProps}
					archivedStudents={this.state.archivedStudents} />);
				break;

			case CLASSES:
				var stageContent = (<RosterUploadClasses {...stageProps} />);
				break;

			case CONFIRM:
				var stageContent = (<RosterUploadConfirm {...stageProps} />);
				break;

			case DONE:
				var stageContent = (
					<div className="uploadingWait">
						<RosterUploadProgressMeter index={5} />
						<strong>Currently uploading...</strong>

						<Spinner center={true} ops={{ length: 20, radius: 15, width: 8, color: "#888" }} />
					</div>
				);
		}

		return (
			<div className="uploadRoster">
				{stageContent}
			</div>
		);
	}
};

const INITIAL = "initial";
const COLUMNS = "columns";
const CLASSES = "classes";
const GRADES = "grades";
const CONFIRM = "confirm";
const DONE = "done";

const STAGES = [INITIAL, COLUMNS, GRADES, CLASSES, CONFIRM, DONE];


const MANUAL = "manual";
const CODE = "class-code";
const UPLOAD = "upload";
const GOOGLE = "google-classroom";
const CLEVER = "clever";

var ALL_METHOD_OPTIONS = [MANUAL, CODE, UPLOAD, GOOGLE, CLEVER];

UploadStudentRoster.propTypes = StrictPropTypes({
	// Function to call once the roster has been uploaded
	uploadRoster: PropTypes.func,
	afterCreate: PropTypes.func,
	effectiveUserID: PropTypes.number,
});

module.exports = UploadStudentRoster;



// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/UploadStudentRoster.js